import { IsAuthProvider, VisitorIdProvider } from '@trwl/provider';
import { PropsWithChildren } from 'react';

interface UserLayoutProps extends PropsWithChildren {
  redirectToLogin?: boolean;
}
export const IsAuthLayout = ({
  children,
  redirectToLogin = true,
}: UserLayoutProps) => {
  return (
    <VisitorIdProvider>
      <IsAuthProvider redirectToLogin={redirectToLogin}>
        {children}
      </IsAuthProvider>
    </VisitorIdProvider>
  );
};
